import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useValueRef } from '@alltrails/core';
import Add from '@alltrails/denali/icons/Add';
import Gallery from '@alltrails/denali/icons/Gallery';
import logCustomRoutePOIExploreSelected from '@alltrails/amplitude/events/logCustomRoutePOIExploreSelected';
import { updateLocationResult } from '@alltrails/explore-service/redux/exploreServiceSlice';
import { useAppDispatch, useAppSelector } from '../../../redux';
import { updateActivePOI, updateSelectedPOI, updateShowPOIPopupMenu } from '../../../redux/reducer';
import useRouteToPoint from '../../CustomRoute/DrawControls/useRouteToPoint';
import ActivePOIPopupOptions from './ActivePOIPopupOptions';

type ActivePOIRoutingOptionsProps = {
  canAddToRoute?: boolean;
};

const ActivePOIRoutingOptions = ({ canAddToRoute = false }: ActivePOIRoutingOptionsProps) => {
  const dispatch = useAppDispatch();
  const { activePOI, isSmartRouting, showPOIPopupMenu } = useAppSelector(state => ({
    activePOI: state.map.activePOI,
    isSmartRouting: state.customRoute.isSmartRouting,
    showPOIPopupMenu: state.map.showPOIPopupMenu
  }));
  const isSmartRoutingRef = useValueRef(isSmartRouting);
  const { routeToPoint } = useRouteToPoint(isSmartRoutingRef);

  const popupOptions = useMemo(
    () => [
      {
        leadingIcon: { icon: { Component: Gallery, size: 'xs' } },
        onClick: () => {
          dispatch(updateSelectedPOI(activePOI));
          dispatch(updateLocationResult(activePOI));
          dispatch(updateShowPOIPopupMenu(false));
          dispatch(updateActivePOI(undefined));
          if (activePOI?.ID) {
            logCustomRoutePOIExploreSelected({ poi_id: activePOI?.ID });
          }
        },
        testId: 'explore-this-spot',
        title: <FormattedMessage defaultMessage="Explore this spot" />
      },
      ...(canAddToRoute
        ? [
            {
              leadingIcon: { icon: { Component: Add, size: 'xs' } },
              onClick: () => {
                if (activePOI?._geoloc) {
                  routeToPoint({ lat: activePOI._geoloc.lat, lng: activePOI._geoloc.lng }, true);
                  dispatch(updateActivePOI(undefined));
                  dispatch(updateSelectedPOI(undefined));
                  dispatch(updateShowPOIPopupMenu(false));
                  dispatch(updateLocationResult(undefined));
                }
              },
              testId: 'add-to-route',
              title: <FormattedMessage defaultMessage="Add to route" />
            }
          ]
        : [])
    ],
    [activePOI, canAddToRoute, dispatch, routeToPoint]
  );

  return <>{activePOI && showPOIPopupMenu && <ActivePOIPopupOptions options={popupOptions} poi={activePOI} />}</>;
};

export default ActivePOIRoutingOptions;
